












































import {Vue, Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "../../../mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";

@Component({})
export default class IzvestajPreostalogRV extends mixins(ComponentBaseMixin) {
    izabraniDatum = new Date();
    vozacId: number = null;
    isBusy = false;

    izvestajPreostalogRV = [];
    columns = [];
    tableOptions = {
        search: true,
        pagination: true,
        headerStyle: () => {return {css: {'font-size': '9px'}}}
    };

    async created() {
        this.columns = [
            {field: 'osoba', title: this.$i18n.t('osoba'), width: 200},
            {field: 'radnoVremeNedelja', title: this.$i18n.t('rvNedelja')},
            {field: 'preostaloVremeDanas', title: this.$i18n.t('preostaloVremeDanas')},
            {field: 'preostaloVremeSutra', title: this.$i18n.t('preostaloVremeSutra')},
            {field: 'preostaloVremeNedelja', title: this.$i18n.t('preostaloVremeNedelja')},
            {field: 'preostaloVremePeriod', title: this.$i18n.t('preostaloVremePeriod')},
            {field: 'prosecnoVremeUPeriodu', title: this.$i18n.t('prosecnoVremeUPeriodu')},
            {field: 'radnoVremeDanas', title: this.$i18n.t('rvDanas')},
        ];
    }

    async pretraziPreostaloRV() {
        const isValid = await (<any>this.$refs.observer).validate();
        if (isValid) {
            try {
                this.isBusy = true;
                this.izvestajPreostalogRV = await this.loadData(() =>
                    dataProxy.vratiPreostaloRadnoVreme(this.izabraniDatum, this.vozacId))();
            } finally {
                this.isBusy = false;
            }
        }
    }
}
